import React from 'react';
import PropTypes from 'prop-types';
import './AcknowledgeButton.scss';

const AcknowledgeButton = ({ isChecked, onClick, label }) => (
  <button
    type="button"
    className={`acknowledge-btn ${isChecked ? 'acknowledge-btn--checked' : ''}`}
    onClick={onClick}
  >
    <span className="acknowledge-btn__circle">
      {isChecked && (
        <svg
          className="acknowledge-btn__check-icon"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 13l4 4L19 7"
            stroke="#fff"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </span>
    {label}
  </button>
);

AcknowledgeButton.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
};

AcknowledgeButton.defaultProps = {
  label: 'ACKNOWLEDGE',
};

export default AcknowledgeButton;
